import React from "react";
import { Phone, Clock, MapPin, ArrowRight, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FastReliableFreightLogisticsInNorthMiami() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="29156" id="our-transport-power" className="dark relative w-full overflow-hidden bg-background py-16 lg:py-24" ref={ref}>
      {}
      <div className="absolute top-0 right-0 -z-10 h-full w-1/3 bg-primary/5 skew-x-12 translate-x-20 hidden lg:block border-l-2 border-primary/20" />
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <Badge variant="outline" className="w-fit border-primary text-primary-foreground bg-primary px-3 py-1 font-default font-bold uppercase tracking-widest rounded-sm">
                <Truck className="mr-2 h-3.5 w-3.5" />
                Industrial Logistics Power
              </Badge>
              
              <h1 className="text-4xl font-default font-extrabold tracking-tighter text-foreground sm:text-5xl xl:text-6xl uppercase leading-[0.9]">
                Heavy-Duty Transport & Last Mile in{" "}
                <span className="text-primary">DFW Market</span>
              </h1>
              
              <p className="max-w-[600px] text-lg text-muted-foreground md:text-xl leading-relaxed font-mono">
                From stone yards to lumber yards, we bridge the gap between bulk materials and their final destination across the Southeast region.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] border-2 border-primary-foreground">
                <Link to="tel:+14695904364">
                  <Phone className="mr-2 h-5 w-5" />
                  +1 (469) 590-4364
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-sm transition-colors duration-200">
                <Link to="#">
                  Request a Quote
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-4 border-t-2 border-border">
              <div className="flex flex-wrap gap-3">
                {[{
                icon: MapPin,
                text: "Dallas / Ft Worth"
              }, {
                icon: Clock,
                text: "Southeast Regional"
              }, {
                icon: Phone,
                text: "Bulk Material Experts"
              }].map((item, i) => <div key={i} data-index={i} className="inline-flex items-center rounded-sm bg-secondary px-3 py-1.5 text-xs font-mono font-bold uppercase text-secondary-foreground border-2 border-border">
                    <item.icon className="mr-2 h-3.5 w-3.5 text-primary" />
                    {item.text}
                  </div>)}
              </div>
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-[500px] lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute -top-6 -right-6 -z-10 h-full w-full rounded-sm bg-primary/10 lg:-right-12 lg:-top-12 border-2 border-primary/20" />
            <div className="absolute -bottom-6 -left-6 -z-10 h-2/3 w-2/3 rounded-sm bg-secondary/50 border-2 border-border" />
            
            <div className="relative overflow-hidden rounded-sm border-2 border-border bg-background shadow-[12px_12px_0px_0px_rgba(255,191,0,0.1)]">
              <div className="absolute inset-0 bg-gradient-to-tr from-background/40 to-transparent mix-blend-multiply z-10 pointer-events-none" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/white_freighter_truck_logistics.png" alt="TransitLink heavy duty semi truck for regional logistics" className="h-full w-full object-cover object-center scale-105 hover:scale-100 transition-transform duration-700 grayscale hover:grayscale-0" />
              
              {}
              <div className="absolute bottom-4 left-4 z-20 hidden sm:flex items-center gap-2 rounded-sm bg-background border-2 border-primary p-3 shadow-md">
                <div className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary text-primary-foreground">
                  <Truck className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Fleet Status</p>
                  <p className="text-sm font-default font-black uppercase text-foreground">Operational</p>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}